// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"OtherB_TheComp__PjFVV"};